export default __webpack_public_path__ + "static/media/globalColored.1bc8ec8d.png";